<template>
  <section class="bg-white dark:bg-gray-900">
    <div class="flex flex-col w-full">
      <h2
        class="mb-4 text-xl font-bold text-gray-900 dark:text-white text-center"
      >
        {{ esEdicion ? "Actualizar Enfermero" : "Agregar Nuevo Esteticista" }}
      </h2>

      <button
        @click="abrirModal"
        class="block sm:w-min sm:whitespace-nowrap text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        type="button"
      >
        Crear Esteticistas
      </button>

      <div
        v-if="mostrarModal"
        @click.self="cerrarModal"
        class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-gray-900 bg-opacity-50"
      >
        <div
          class="max-w-md sm:max-w-lg md:pb-3 md:h-min md:max-w-xl lg:max-w-2xl bg-white rounded-lg shadow dark:bg-gray-700 mx-3 md:m-1 sm:mx-auto flex flex-col gap-3 justify-center items-center content-center sm:content-none sm:justify-start sm:items-start sm:p-0 sm:m-0 self-baseline p-3 m-3"
        >
          <form
            @submit.prevent="
              esEdicion ? actualizarEnfermero() : crearEnfermero()
            "
            class="mx-auto max-w-2xl sm:p-1 sm:m-0 sm:h-fit sm:flex sm:flex-col"
          >
            <div class="grid gap-4 sm:grid-cols-2 sm:gap-6">
              <div class="sm:col-span-2">
                <label
                  for="nombre"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Nombre</label
                >
                <input
                  v-model="nombre"
                  type="text"
                  id="nombre"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  placeholder="Nombre del esteticista"
                  required
                />
              </div>

              <div class="sm:col-span-2">
                <label
                  for="apellido"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Apellido</label
                >
                <input
                  v-model="apellido"
                  type="text"
                  id="apellido"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  placeholder="Apellido del esteticista"
                  required
                />
              </div>

              <div class="sm:col-span-2">
                <label
                  for="telefono"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Teléfono</label
                >
                <input
                  v-model="telefono"
                  type="tel"
                  id="telefono"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  placeholder="Número de teléfono"
                  required
                />
              </div>

              <div class="sm:col-span-2">
                <label
                  for="email"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >Correo Electrónico</label
                >
                <input
                  v-model="email"
                  type="email"
                  id="email"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  placeholder="correo@ejemplo.com"
                  required
                />
              </div>

              <div class="sm:col-span-2">
                <label class="relative inline-flex items-center cursor-pointer">
                  <input
                    v-model="activo"
                    type="checkbox"
                    class="sr-only peer"
                  />
                  <div
                    class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"
                  ></div>
                  <span
                    class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >Activo</span
                  >
                </label>
              </div>
            </div>

            <div class="flex justify-end space-x-4 mt-4">
              <button
                @click="cerrarModal"
                type="button"
                class="inline-flex items-center mt-4 px-5 py-2.5 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-700 dark:bg-gray-600 dark:hover:bg-gray-700 dark:text-white"
              >
                Cerrar
              </button>
              <button
                type="submit"
                class="inline-flex items-center px-5 py-2.5 mt-4 sm:mt-6 text-sm font-medium text-center text-white bg-blue-700 rounded-lg focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-900 hover:bg-blue-800"
              >
                {{ esEdicion ? "Actualizar Enfermero" : "Crear Enfermero" }}
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Lista de enfermeros -->
      <div class="flex flex-col w-full overflow-x-auto">
        <h2
          class="text-xl font-bold text-gray-900 dark:text-white mb-4 text-center"
        >
          Lista de Esteticistas
        </h2>
        <div class="w-full relative overflow-x-auto">
          <table
            class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
          >
            <thead
              class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
            >
              <tr>
                <th scope="col" class="px-6 py-3">Nombre</th>
                <th scope="col" class="px-6 py-3">Apellido</th>
                <th scope="col" class="px-6 py-3">Teléfono</th>
                <th scope="col" class="px-6 py-3">Email</th>
                <th scope="col" class="px-6 py-3">Estado</th>
                <th scope="col" class="px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="enfermero in enfermeros"
                :key="enfermero.id"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
              >
                <th
                  scope="row"
                  class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  {{ enfermero.nombre }}
                </th>
                <td class="px-6 py-4">
                  {{ enfermero.apellido }}
                </td>
                <td class="px-6 py-4">
                  {{ enfermero.telefono }}
                </td>
                <td class="px-6 py-4">
                  {{ enfermero.email }}
                </td>
                <td class="px-6 py-4">
                  <span
                    :class="
                      enfermero.activo
                        ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
                        : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300'
                    "
                    class="text-xs font-medium px-2.5 py-0.5 rounded"
                  >
                    {{ enfermero.activo ? "Activo" : "Inactivo" }}
                  </span>
                </td>
                <td class="px-6 py-4 flex gap-3">
                  <button
                    @click="editarEnfermero(enfermero)"
                    class="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    Editar
                  </button>
                  <button
                    @click="eliminarEnfermero(enfermero.id)"
                    class="font-medium text-red-600 dark:text-red-500 hover:underline"
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  collection,
  doc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import {
  getAuth,
  createUserWithEmailAndPassword,
  fetchSignInMethodsForEmail,
} from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { db, firebaseConfig } from "../../firebase";
import { initializeApp, deleteApp } from "firebase/app";

export default {
  data() {
    return {
      mostrarModal: false,
      nombre: "",
      apellido: "",
      telefono: "",
      email: "",
      activo: true,
      enfermeros: [],
      esEdicion: false,
      enfermeroEditandoId: null,
      serviciosDisponibles: [],
      serviciosAsignados: [],
    };
  },
  methods: {
    abrirModal() {
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.mostrarModal = false;
    },

    async cargarEnfermeros() {
      const querySnapshot = await getDocs(collection(db, "enfermeros"));
      this.enfermeros = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
    },

    // Genera una contraseña aleatoria de 8 caracteres
    generarContraseñaAleatoria() {
      const caracteres =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@$*";
      let contraseña = "";
      for (let i = 0; i < 8; i++) {
        const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
        contraseña += caracteres[indiceAleatorio];
      }
      return contraseña;
    },

    // Reemplaza tu función por esta
    async registerNewUser(email, password) {
      const secondaryApp = initializeApp(firebaseConfig, "Secondary");
      try {
        const secondaryAuth = getAuth(secondaryApp);
        const userCredential = await createUserWithEmailAndPassword(
          secondaryAuth,
          email,
          password
        );
        return userCredential.user;
      } finally {
        // Por qué: evitar apps zombis aun si falla createUser
        try {
          await deleteApp(secondaryApp);
        } catch {
          /* ignore */
        }
      }
    },

    async cargarServicios() {
      const snapshot = await getDocs(collection(db, "productos"));
      this.serviciosDisponibles = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter(
          (p) =>
            p.tipo === "servicio" && p.mostrarWeb === true && p.activo !== false
        );
    },

    async crearEnfermero() {
      const auth = getAuth();
      const emailNorm = (this.email || "").trim().toLowerCase(); // Por qué: evitar duplicados por mayúsculas/minúsculas
      const nuevoEnfermero = {
        nombre: this.nombre,
        apellido: this.apellido,
        telefono: this.telefono,
        email: emailNorm,
        emailLower: emailNorm,
        activo: this.activo,
        role: "enfermero",
        ubicacionActual: { lat: 18.2208, lng: -66.5901 }, // default sensato
      };

      try {
        // 1) Verificar que no exista ya en Auth
        const signInMethods = await fetchSignInMethodsForEmail(auth, emailNorm);
        if (signInMethods.length > 0) {
          alert("Este correo ya está registrado.");
          return;
        }

        // 2) Crear usuario en Auth (app secundaria) con password temporal
        const temporalPassword = this.generarContraseñaAleatoria();
        const user = await this.registerNewUser(emailNorm, temporalPassword);

        // 3) Guardar ficha en Firestore (colección enfermeros)
        await setDoc(doc(db, "enfermeros", user.uid), {
          ...nuevoEnfermero,
          uid: user.uid,
          passwordTemporal: true,
        });

        
        const functions = getFunctions();
        const enviarCorreo = httpsCallable(functions, "enviarCorreoEnfermero");

        await enviarCorreo({
          email: emailNorm,
          nombre: this.nombre,
          enfermeroId: user.uid,
          temporalPassword, // Tu función lo espera para armar el enlace "crear-cuenta"
        });

        // 5) UI refresh
        await this.cargarEnfermeros();
        this.resetForm();
        this.cerrarModal();
        alert("Invitación enviada al enfermero.");
      } catch (e) {
        console.error(
          "Error al crear/enviar invitación:",
          e?.code,
          e?.message,
          e
        );
        alert(
          `Hubo un error al crear/enviar invitación: ${
            e?.message || "revisa logs de Functions"
          }`
        );
      }
    },

    async actualizarEnfermero() {
      try {
        await updateDoc(doc(db, "enfermeros", this.enfermeroEditandoId), {
          nombre: this.nombre,
          apellido: this.apellido,
          telefono: this.telefono,
          email: this.email,
          activo: this.activo,
        });
        alert("Esteticista actualizado con éxito!");
        this.cargarEnfermeros();
        this.resetForm();
        this.cerrarModal();
      } catch (e) {
        console.error("Error al actualizar el esteticista:", e);
      }
    },

    async eliminarEnfermero(id) {
      if (confirm("¿Estás seguro de eliminar este Esteticista?")) {
        await deleteDoc(doc(db, "enfermeros", id));
        const functions = getFunctions();

        const deleteUser = httpsCallable(functions, "eliminarUsuario");
        await deleteUser({ uid: id });
        alert("Enfermero eliminado.");
        this.cargarEnfermeros();
      }
    },

    editarEnfermero(enfermero) {
      this.nombre = enfermero.nombre;
      this.apellido = enfermero.apellido;
      this.telefono = enfermero.telefono;
      this.email = enfermero.email;
      this.activo = enfermero.activo;
      this.esEdicion = true;
      this.enfermeroEditandoId = enfermero.id;

      // Abrir el modal
      this.abrirModal();
    },

    resetForm() {
      this.nombre = "";
      this.apellido = "";
      this.telefono = "";
      this.email = "";
      this.activo = true;
      this.esEdicion = false;
      this.enfermeroEditandoId = null;
    },
  },

  mounted() {
    this.cargarEnfermeros();
  },
};
</script>

<style scoped>
/* No se necesitan estilos adicionales ya que usamos Tailwind */
</style>
